"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportSalesOrderLineSearchResponse = void 0;
const common_1 = require("../../../common");
const models_1 = require("../../models");
class ImportSalesOrderLineSearchResponse extends common_1.PaginatedResponse {
}
exports.ImportSalesOrderLineSearchResponse = ImportSalesOrderLineSearchResponse;
//# sourceMappingURL=import-sales-order-line-search.response.js.map